// src/api/pricingApi.js

import httpClient from "../utils/httpClient";


/**
 * Creates a Stripe Checkout Session and returns { url }
 * payload:
 *  - billingAccountId (required)
 *  - planCode (required)
 *  - quantity (optional; required for business seat plans)
 */
export async function createCheckoutSession({ planCode, quantity }) {
  const payload = { planCode };
  if (quantity != null) payload.quantity = quantity;

  // If your httpClient returns JSON directly:
  // return httpClient.post("/billing/checkout", payload);

  // If your httpClient returns { data } like axios:
  const res = await httpClient.post("/api/billing/checkout", payload);
  return res?.data ?? res;
}


// src/api/billingApi.js


export async function openBillingPortal() {
  const res = await httpClient.post('/api/billing/portal');
  return res.data; // MUST be { url: "https://billing.stripe.com/..." }
}

export async function resumeSubscription() {
    const res = await httpClient.post("/api/billing/subscription/resume");
    return res.data;
  }
  